import React, { useState, useEffect, useRef } from 'react';
import { Button, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, ButtonDropdown, Dropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Trans } from 'react-i18next';
import { useHistory, Link } from 'react-router-dom';
import styles from "assets/scss/fixed_assets.module.css";
import { Page, required, DatePicker, FormGroup } from 'components/common';
import BackButton from 'components/refactoring/BackButton';
import { Control } from 'react-redux-form';
import AddAssetType from './AddAssetType';
import { useOrganisationContext } from "hooks";
import { ApiClient, } from "services";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";

const AddNewAsset = ({ onSave, onCancel, t, match, model }) => {
    const history = useHistory();
    const id = match.params.id;
    const isEdit = !(id === "new")
    const [asset, setAsset] = useState({});
    const [isDraft, setDraft] = useState(false)
    const [prefix, setAssetPrefix] = useState('');
    const [nextNumber, setAssetNumber] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAssetModalOpen, setIsAssetModalOpen] = useState(false);
    const assetTypesRef = useRef();
    const [accountsDetails, setAccountsDetails] = useState([]);
    const [assetAccounts, setAssetAccounts] = useState([]);
    const [toggle, setToggle] = useState(false)
    const [copiedAsset, setCopiedAsset] = useState(null);
    const [enabledField, setEnabledField] = useState('depreciationRate');
    const [registeredAssets, setRegisteredAssets] = useState([]);
    const [assetDetail, setAssetDetail] = useState({});

    const [formValues, setFormValues] = useState({
        depreciationMethod: '',
        averagingMethod: '',
        depreciationRate: '',
        effectiveLifeYears: ''
    });
    const { selectedOrganisation } = useOrganisationContext();
    const client = ApiClient();

    const connectedOrg = selectedOrganisation ? selectedOrganisation?.id : 0;
    const asset_id = match.params.id;


    const { dispatch, value, setValue, Form, save, loaded, load, getTitle } =
        useForm({
            model,
        });

    const fetchAsset = async () => {
        if (asset_id && asset_id != "new") {
            const response = await client.get(`/fixed-assets/${connectedOrg}/assets/${asset_id}`)
            setValue(response.data);
        };
    };

    function handleAssetTypeSelect(val) {
        if (val) {
            const asset_type = assetTypesRef.current?.filter((assetType) => assetType?.assetTypeId === val)[0]
            const main_account = assetAccounts.find(account => account?.AccountID === asset_type?.fixedAssetAccountId);
            const acc_depre_account = assetAccounts.find(account => account?.AccountID === asset_type?.accumulatedDepreciationAccountId);
            const depre_account = assetAccounts.find(account => account?.AccountID === asset_type?.depreciationExpenseAccountId);
            setAccountsDetails({ 'main_account': main_account, 'acc_depre_account': acc_depre_account, 'depre_account': depre_account })
            if (value.assetTypeId) {
                const depreciationValue = asset_type?.bookDepreciationSetting?.depreciationRate !== undefined
                    ? { depreciationRate: asset_type?.bookDepreciationSetting.depreciationRate }
                    : { effectiveLifeYears: asset_type?.bookDepreciationSetting?.effectiveLifeYears };
                setValue({
                    ...value,
                    assetTypeId: val,
                    bookDepreciationSetting:
                    {
                        ...value?.averagingMethod,
                        averagingMethod: asset_type?.bookDepreciationSetting?.averagingMethod,
                        depreciationMethod: asset_type?.bookDepreciationSetting?.depreciationMethod,
                        ...depreciationValue
                    }
                })
            }
        }
        return val
    };


    useEffect(() => {
        if (isEdit) {
            const existingAsset = registeredAssets?.find(a => a?.assetId === asset_id);
            if (existingAsset) {
                setAsset(existingAsset);
            }
        } else if (copiedAsset) {
            setAsset(copiedAsset);
        }
        fetchAssetAccounts();
        fetchAssetTypes();
        fetchAssetNumbers();
        fetchAsset();
        fetchRegisteredAssets();
    }, [isEdit, copiedAsset]);

    useEffect(() => {
        if (value?.bookDepreciationSetting?.depreciationRate !== undefined) {
            setEnabledField("depreciationRate");
        } else if (
            value?.bookDepreciationSetting?.effectiveLifeYears !== undefined
        ) {
            setEnabledField("effectiveLifeYears");
        }
    }, [value]);


    const fetchAssetNumbers = async (status) => {
        const response = await client.get(`/get-asset-number/${connectedOrg}/settings`);
        const { asset_prefix, asset_number } = response?.data;
        setAssetPrefix(asset_prefix);
        setAssetNumber(asset_number);

    };



    const fetchAssets = async (status) => {
        try {
            const response = await client.get(`/fixed-assets/${connectedOrg}/assets`, {
                params: {
                    query: {
                        "Status": status
                    }
                }
            });
            let data = response.data.items;

            if (status === 'REGISTERED') {
                setRegisteredAssets(data);
            };

        } catch (error) {
            NotificationManager.error(t("Error fetching assets"));
            console.error(error);
        }
    };

    const fetchRegisteredAssets = () => {
        fetchAssets('REGISTERED')
    }
    const handleAssetTypeSubmit = async (values) => {

        try {
            const response = await client.post(`/asset-types/${connectedOrg}/assettypes`, values);
            assetTypesRef.current = [...assetTypesRef.current, response.data];
            NotificationManager.success(t("Asset Type submitted successfully"));
        } catch (error) {
            NotificationManager.error(t("Error submitting data"));
            console.error(error);
        }
        toggleModal();
    };

    const fetchAssetTypes = async () => {
        try {
            const response = await client.get(`/asset-types/${connectedOrg}/assettypes`);
            assetTypesRef.current = response.data;
        } catch (error) {
            NotificationManager.error(t("Error fetching asset types"));
            console.error(error);
        }
    };

    const fetchAssetAccounts = async () => {
        try {
            const response = await client.get(`/xero/${connectedOrg}/accounts`);
            setAssetAccounts(response.data);
        } catch (error) {
            NotificationManager.error(t("Error fetching asset accounts"));
            console.error(error);
        }
    };

    const handleSaveAssetNumber = () => {
        assetNumberToggleModal();
    };

    const assetNumberToggleModal = () => {
        setIsAssetModalOpen(!isAssetModalOpen);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleAssetSubmit = async (values) => {
        const updated_values = {
            ...values,
            asset_status: isDraft ? 'DR' : 'RE',
            assetNumber: value?.assetNumber ? value?.assetNumber : `${prefix}${nextNumber}`,
            assetStatus: isDraft ? "DRAFT" : "REGISTERED",
        };
        try {
            if (isEdit) {
                const response = await client.put(`/fixed-assets/${connectedOrg}/assets/${asset_id}/update_asset`, updated_values);
                NotificationManager.success("Asset updated successfully");
            } else {
                const response = await client.post(`/fixed-assets/${connectedOrg}/assets`, updated_values);
                NotificationManager.success("Asset submitted successfully");
            }
        } catch (error) {
            NotificationManager.error("Error submitting asset data");
            console.error(error);
        }
    };


    const handleCopyAsset = () => {
        const assetToCopy = registeredAssets?.find(a => a.assetId === id);
        if (assetToCopy) {
            setCopiedAsset({ ...assetToCopy, id: 'new' });
            history.push('/fixed-assets/new');
        }
    };

    const handleRadioChange = (field) => {
        setEnabledField(field);
        setFormValues((prev) => ({
            ...prev,
            depreciationRate:
                field === "depreciationRate"
                    ? prev.bookDepreciationSetting?.depreciationRate
                    : "",
            effectiveLifeYears:
                field === "effectiveLifeYears"
                    ? prev.bookDepreciationSetting?.effectiveLifeYears
                    : "",
        }));
    };

    function handleButtonClick(url) {
        window.open(url, '_blank');
    };

    return (
        <Page title={t(isEdit ? t("Edit Asset") : t("Add New Asset"))}>
            <Row>
                <Col md={10}>
                    <BackButton />
                </Col>
                <Col md={2} className="text-right">
                    {isEdit &&
                        <ButtonDropdown toggle={() => setToggle(!toggle)}>
                            <Dropdown isOpen={toggle} toggle={() => setToggle(!toggle)} direction={"down"}>
                                <DropdownToggle caret className="btn btn-success" style={{ boxShadow: "none" }}>Options</DropdownToggle>
                                <DropdownMenu >
                                    <DropdownItem onClick={handleCopyAsset}><Trans>Copy</Trans></DropdownItem>
                                    <DropdownItem onClick={() => handleButtonClick(`https://fixedassets.xero.com/?#asset/${assetDetail?.assetId}`)}><Trans>Delete</Trans></DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </ButtonDropdown>
                    }
                </Col>
            </Row>
            <Form onSubmit={handleAssetSubmit}>
                <Row form>
                    <Col md={6}>
                        <FormGroup label="Asset Name">
                            <Control.text
                                model=".assetName"
                                className="form-control"
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup label="Asset Number">
                            <Control.text
                                model=".assetNumber"
                                className="form-control"
                                // id="asset_number"
                                style={{ backgroundColor: '#F4F7FE' }}
                                value={value?.assetNumber ? value?.assetNumber : `${prefix}${nextNumber}`}
                                // onChange={(e) => {
                                //     setAssetPrefix(e.target.value);
                                //     setAssetNumber(e.target.value.replace(prefix, ''));
                                // }}
                                onClick={assetNumberToggleModal}
                            // readOnly
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row form className='mt-2'>
                    <Col md={6}>
                        <FormGroup model=".purchaseDate" label="Purchase Date">
                            <DatePicker
                                type="date"
                                className="form-control"
                                model=".purchaseDate"
                                placeholder="Purchase date"
                                disabled={value?.accountingBookValue && value?.accountingBookValue !== value?.purchasePrice}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup label="Purchase Price">
                            <Control.text
                                model=".purchasePrice"
                                type="number"
                                className="form-control"
                                disabled={value?.accountingBookValue && value?.accountingBookValue !== value?.purchasePrice}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row form className='mt-2'>
                    <Col md={6}>
                        <FormGroup label="Warranty Expire">
                            <DatePicker
                                type="date"
                                className="form-control"
                                model=".warrantyExpiryDate"
                                placeholder="Warranty Expire"
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup label="Serial Number">
                            <Control.text
                                model=".serialNumber"
                                type="number"
                                className="form-control"
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row form className='mt-2'>
                    <Col md={6}>
                        <FormGroup label="Asset Type">
                            <Control.select
                                model=".assetTypeId"
                                className="form-control"
                                style={{ backgroundColor: '#F4F7FE' }}
                                parser={handleAssetTypeSelect}
                            >
                                <option value="">{t('Select...')}</option>
                                {assetTypesRef.current?.map((type, index) => (
                                    <option key={index} value={type.assetTypeId}>{type?.assetTypeName}</option>
                                ))}
                            </Control.select>
                        </FormGroup>
                        <div>
                            <Link color='primary' className={`mt-2 mb-2 ${styles.add_asset_type}`} onClick={toggleModal}><Trans>Add Asset Type</Trans></Link>
                        </div>
                    </Col>
                    <Col md={6}>
                        <FormGroup label="Region *">
                            <Control.select
                                model=".region"
                                className="form-control"
                            >
                                <option value="">{t('Select...')}</option>
                                <option value="E">{t("East Side")}</option>
                                <option value="N">{t("North")}</option>
                                <option value="S">{t("South")}</option>
                                <option value="W">{t("West Coast")}</option>
                            </Control.select>
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col md={12}>
                        {value.assetTypeId && (
                            <div className="asset-type-details" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ flex: 1, paddingRight: '10px' }}>
                                    <strong>{t('Asset Account Information')}:</strong>
                                    <p>{accountsDetails?.main_account?.Code} - {accountsDetails?.main_account?.Name}</p>
                                </div>
                                <div style={{ flex: 1, paddingRight: '10px' }}>
                                    <strong>{t('Accumulated Depreciation Account Information')}:</strong>
                                    <p>{accountsDetails?.acc_depre_account?.Code} - {accountsDetails?.acc_depre_account?.Name}</p>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <strong>{t('Depreciation Expense Account Information')}:</strong>
                                    <p>{accountsDetails?.depre_account?.Code} - {accountsDetails?.depre_account?.Name}</p>
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
                <Row form className='mt-2'>
                    <Col md={12}>
                        <FormGroup label="Description *">
                            <Control.textarea
                                model=".description"
                                rows="4"
                                className="form-control"
                                id="description"
                                style={{ backgroundColor: '#F4F7FE' }}
                                validators={{ required }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row form className='mt-2'>
                    <Col md={4}>
                        <FormGroup label="Depreciation Date">
                            <DatePicker
                                type="date"
                                className="form-control"
                                model=".bookDepreciationDetail.depreciationStartDate"
                                placeholder="Depreciation Date"
                                disabled={value?.accountingBookValue && value?.accountingBookValue !== value?.purchasePrice}
                                validators={{ required }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup label="Cost Unit">
                            <Control.text
                                model=".bookDepreciationSetting.costLimit"
                                type="number"
                                className="form-control"
                                id="cost_limit"
                                style={{ backgroundColor: '#F4F7FE' }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup label="Residual Value">
                            <Control.text
                                model=".bookDepreciationSetting.residualValue"
                                type="number"
                                className="form-control"
                                id="residual_value"
                                style={{ backgroundColor: '#F4F7FE' }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row form style={{ flexWrap: "nowrap", alignItems: "end" }} className='mt-2'>
                    <Col md={3}>
                        <FormGroup label="Depreciation Method *">
                            <Control.select
                                model=".bookDepreciationSetting.depreciationMethod"
                                className="form-control"
                                validators={{ required }}
                            >
                                <option value="">{t('Select...')}</option>
                                <option value="NoDepreciation">{t("No Depreciation")}</option>
                                <option value="StraightLine">{t("Straight Line")}</option>
                                <option value="DiminishingValue100">{t("Diminishing Value 100")}</option>
                                <option value="DiminishingValue150">{t("Diminishing Value 150")}</option>
                                <option value="DiminishingValue200">{t("Diminishing Value 200")}</option>
                                <option value="FullDepreciation">{t("Full Depreciation")}</option>
                            </Control.select>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup label="Averaging Method *">
                            <Control.select
                                model=".bookDepreciationSetting.averagingMethod"
                                className="form-control"
                                validators={{ required }}
                            >
                                <option value="">{t('Select...')}</option>
                                <option value="ActualDays">{t("Actual Days")}</option>
                                <option value="FullMonth">{t("Full Month")}</option>
                            </Control.select>
                        </FormGroup>
                    </Col>
                    <div className="rate form-row align-items-center mx-2">
                        <div className="in ml-3" style={{ paddingTop: "2rem" }}>
                            <input
                                type="radio"
                                checked={value?.bookDepreciationSetting?.depreciationRate && enabledField === 'depreciationRate'}
                                onChange={() => handleRadioChange('depreciationRate')}
                            />
                        </div>
                        <Col md={10} className='px-2'>
                            <FormGroup label="Rate *" className="">
                                <Control.text
                                    model=".bookDepreciationSetting.depreciationRate"
                                    type="number"
                                    className="form-control"
                                    disabled={enabledField !== 'depreciationRate'}
                                // validators={{ required }}
                                />
                            </FormGroup>
                        </Col>
                    </div>

                    <div className="rate form-row align-items-center mx-2">
                        <div className="in ml-3" style={{ paddingTop: "2rem" }}>
                            <input
                                type="radio"
                                checked={value?.bookDepreciationSetting?.effectiveLifeYears && enabledField === 'effectiveLifeYears'}
                                onChange={() => handleRadioChange('effectiveLifeYears')}
                            />
                        </div>
                        <Col md={10} className='px-2'>

                            <FormGroup label="Effective Life *">
                                <Control.text
                                    model=".bookDepreciationSetting.effectiveLifeYears"
                                    type="number"
                                    className="form-control"
                                    disabled={enabledField !== 'effectiveLifeYears'}
                                // validators={{ required }}
                                />
                            </FormGroup>
                        </Col>
                    </div>
                </Row>
                {isEdit && (
                    <div className="d-flex  justify-content-between align-items-center my-2">
                        <div>
                            <Button color="danger"><Trans>Cancel</Trans></Button>
                        </div>
                        <>
                            <div>
                                {value?.assetStatus === "Draft" && (
                                    <>
                                        <Button color="primary" type="submit" onClick={() => setDraft(value?.assetStatus === "Draft" ? true : false)} className="ml-auto"><Trans>Save as draft</Trans></Button>
                                        <Button color="primary" type="submit" onClick={() => setDraft(value?.assetStatus === "Draft" && false)} className="ml-auto"><Trans>Register</Trans></Button>
                                    </>
                                )}
                                {value?.assetStatus === "Registered" && (
                                    <Button color="primary" type="submit" onClick={() => setDraft(value?.assetStatus === "Registered" && false)} className="ml-auto"><Trans>Update</Trans></Button>
                                )}
                            </div>
                        </>
                    </div>
                )}
                {!isEdit && (
                    <div className="d-flex justify-content-between my-2">
                        <Button color="danger"><Trans>Cancel</Trans></Button>

                        <>
                            <Button color="primary" type="submit" onClick={() => setDraft(true)}><Trans>Save as draft</Trans></Button>
                            <Button color="primary" type="submit" onClick={() => setDraft(false)} className="ml-auto"><Trans>Register</Trans></Button>
                        </>
                    </div>
                )}

            </Form>
            <Modal isOpen={isAssetModalOpen} toggle={assetNumberToggleModal}>
                <Form>
                    <ModalHeader toggle={assetNumberToggleModal}><Trans>Edit Asset Number</Trans></ModalHeader>
                    <ModalBody>
                        {/* <FormGroup label="Prefix">
                            <Control.text
                                model=".prefix"
                                className="form-control"
                            />
                        </FormGroup> */}
                        <FormGroup label="Next Number">
                            <Control.text
                                model=".assetNumber"
                                className="form-control"
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={assetNumberToggleModal}><Trans>Cancel</Trans></Button>
                        <Button color="primary" onClick={handleSaveAssetNumber}><Trans>Save</Trans></Button>
                    </ModalFooter>
                </Form>
            </Modal>
            <AddAssetType isOpen={isModalOpen} toggle={toggleModal} onSave={handleAssetTypeSubmit} assetAccounts={assetAccounts} t={t} />
        </Page>
    );
};

export default AddNewAsset;
